import React, { useState, useEffect } from "react";
import TaskBoardLists from "./TaskBoardLists";
import Select, { components } from "react-select";
import Skeleton from "react-loading-skeleton";

export default function TaskBoard({
  data,
  mileStones,
  currentMilestone,
  taskData,
}) {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "314.04px",
      minHeight: "27px",
      border: "none",
      borderBottom: "1px solid #E5E3DC",
      borderRadius: "0",
      boxShadow: "none",
      cursor: "pointer",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      padding: "8px 12px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }),
  };

  const [options, setOptions] = useState([]);
  const [selectedOptionId, setSelectedOptionId] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (mileStones && mileStones?.length > 0) {
      const apiOptions = mileStones.map((item) => ({
        value: item._id,
        label: item.title,
      }));
      setOptions(apiOptions);
      const defaultValue = apiOptions.find(
        (item) => item.value === currentMilestone[0].milestone._id
      );
      setSelectedOptionId(defaultValue);
    }
  }, [mileStones, currentMilestone]);

  const handleSelectChange = (selectedOption) => {
    setIsLoading(true);
    setSelectedOptionId(selectedOption);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  // Custom Option Component
  const CustomOption = (props) => {
    const { data } = props;
    const isCurrent =
      data.value === currentMilestone[0].milestone._id &&
      currentMilestone[0].milestone.is_current_milestone;

    return (
      <components.Option {...props}>
        <span>{data.label}</span>
        {isCurrent && (
          <button className="bg-theme-avail-fg w-[60px] rounded-theme-pill text-white text-[11px]">
            Current
          </button>
        )}
      </components.Option>
    );
  };

  return (
    <>
      {mileStones?.length > 0 ? (
        <div className="mb-6 pl-3">
          <p className="text-theme-fg-3 font-medium text-xs pb-2">
            Current Milestone
          </p>
          <div className="w-fit mb-6">
            <Select
              placeholder="Select Status"
              value={selectedOptionId}
              options={options}
              styles={customStyles}
              className="text-[20px] font-medium"
              onChange={handleSelectChange}
              components={{
                Option: CustomOption,
                DropdownIndicator: () => (
                  <svg
                    width="10"
                    height="8"
                    viewBox="0 0 10 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-3 mr-2"
                  >
                    <path
                      d="M5 6.66699L10 0.000326157L0 0.000326157L5 6.66699Z"
                      fill="#8A8A82"
                    />
                  </svg>
                ),
              }}
            />
          </div>
          {isLoading ? (
            <div className="max-w-full grid sm:grid-cols-2 xl:grid-cols-4 xl:w-full gap-6 overflow-x-auto pt-11 pb-7">
              <Skeleton count={4} />{" "}
              <Skeleton count={4} />{" "}
              <Skeleton count={4} />{" "}
              <Skeleton count={4} />
            </div>
          ) : (
            <TaskBoardLists
              data={data}
              selectedMilestoneId={selectedOptionId?.value}
            />
          )}
        </div>
      ) : (
        <div className="text-center pt-5">
          <p className="text-theme-fg-3">No Milestone Found</p>
        </div>
      )}
    </>
  );
}
